import script from "./AppRoundButton.vue?vue&type=script&setup=true&lang=js"
export * from "./AppRoundButton.vue?vue&type=script&setup=true&lang=js"

import "./AppRoundButton.vue?vue&type=style&index=0&id=828d4872&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-828d4872"]])

export default __exports__